module.exports = __webpack_public_path__ + "img/DSC_0066.dc3941b7.jpg";